// extracted by mini-css-extract-plugin
export var active = "_4c-7";
export var container = "_4c-0";
export var evenWidth = "_4c-4";
export var large = "_4c-5";
export var outlet = "_4c-8";
export var slide = "_4c-2";
export var small = "_4c-6";
export var tab = "_4c-3";
export var tabs = "_4c-1";